import { jwtDecode } from 'jwt-decode';
import moment from 'moment';
import { rangeOverlap } from './Times';
import { EmployeeService } from 'services/EmployeeService';

const employee = new EmployeeService();

const gettingTags = async (setLoading, setTags, setTag, setEmployees, setEmployee, setRows, view, params) => {
    setLoading(true);

    await employee.employee
        .getTags()
        .then(async (response) => {
            const tags = jwtDecode(localStorage.getItem('access_token'))?.tags;

            const responseTags = response
                .map((tag) => ({
                    id: tag.tag_id,
                    name: tag.tag_name,
                }))
                .filter((tag) => tags.includes(tag.id));

            setTags(responseTags);

            setTag(responseTags);

            await gettingEmployees(
                setLoading,
                setEmployees,
                setEmployee,
                setRows,
                response
                    .map((tag) => tag) //.tag_id
                    .filter((tag) => tags.includes(tag.tag_id)),
                view,
                {
                    ...params,
                    tags_id__in: responseTags.map((rt) => rt.id).join(','),
                },
            );
        })
        .catch((error) => {
            console.error(error.message);
        })
        .finally(() => {
            setLoading(false);
        });
};

const gettingEmployees = async (setLoading, setEmployees, setEmployee, setRows, tags, view, params) => {
    setLoading(true);

    await employee.employee
        .getEmployees({
            ...params,
            without_hiring: true,
            active: view !== 'employee' ? true : undefined,
        })
        .then((response) => {
            setRows(
                response?.map((e) => {
                    const orgpaths = e.orgpath.sort((a, b) => moment(a.Range.end_date).diff(moment(b.Range.end_date)));

                    const orgpathInRangeOfSearch = orgpaths.filter((o) =>
                        rangeOverlap(
                            moment(params.start_date, 'YYYY-MM-DD'),
                            moment(params.end_date, 'YYYY-MM-DD'),
                            moment(o?.Range?.start_date, 'YYYY-MM-DDTHH:mm:ss'),
                            moment(o?.Range?.end_date, 'YYYY-MM-DDTHH:mm:ss'),
                        ),
                    );
                    const row = {
                        ...e,
                        id: e.employee_id,
                        full_name: `${e.first_name} ${e.last_name}`,
                        person_number: e.document_employee,
                        hire_date: orgpathInRangeOfSearch,
                        term_date: moment(e.contract_end_date, 'YYYY-MM-DDTHH:mm:ss').format('YYYY-MM-DD'),
                        closed_period: moment(e.pay_period_end, 'YYYY-MM-DDTHH:mm:ss').format('YYYY-MM-DD'),
                        org_path: orgpathInRangeOfSearch,
                    };

                    //console.log("row", row);
                    // el hire_date es el rango del contrato activo o
                    return row;
                }),
            );

            setEmployees(
                response?.flatMap((data) =>
                    data.tags.map((tag) => ({
                        id: data?.employee_id,
                        full_name: `${data?.first_name} ${data?.last_name}`,
                        document_employee: data?.document_employee,
                        tag: tags.find((t) => t.tag_id === tag.tag_id)?.tag_name,
                        pay_period_end: data?.pay_period_end,
                        contract_end_date: moment(data?.contract_end_date, 'YYYY-MM-DDTHH:mm:ss').format('YYYY-MM-DD'),
                    })),
                ),
            );

            if (view === 'timecard') {
                setEmployee(
                    response?.length > 0
                        ? [
                              response?.flatMap((data) =>
                                  data.tags.map((tag) => ({
                                      id: data?.employee_id,
                                      full_name: `${data?.first_name} ${data?.last_name}`,
                                      document_employee: data?.document_employee,
                                      tag: tags.find((t) => t.tag_id === tag.tag_id)?.tag_name,
                                      pay_period_end: data?.pay_period_end,
                                      contract_end_date: moment(data?.contract_end_date, 'YYYY-MM-DDTHH:mm:ss').format('YYYY-MM-DD'),
                                  })),
                              )[0],
                          ]
                        : [],
                );
            } else {
                setEmployee(
                    response?.flatMap((data) =>
                        data.tags.map((tag) => ({
                            id: data?.employee_id,
                            full_name: `${data?.first_name} ${data?.last_name}`,
                            document_employee: data?.document_employee,
                            tag: tags.find((t) => t.tag_id === tag.tag_id)?.tag_name,
                            pay_period_end: data?.pay_period_end,
                            contract_end_date: moment(data?.contract_end_date, 'YYYY-MM-DDTHH:mm:ss').format('YYYY-MM-DD'),
                        })),
                    ),
                );
            }
        })
        .catch((error) => {
            console.error(error.message);
        })
        .finally(() => {
            setLoading(false);
        });
};

export { gettingTags, gettingEmployees };
